import { TypedHandler } from './../../../types/handlers';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { AttributeComparisonComponent } from './../../attribute-comparison/attribute-comparison.component';
import { AvailCriteria, ConfigAttribute } from 'app/types/project-config';
import { AttributeConditionsDialogService } from './attribute-conditions-dialog.service';
import { SubscriptionMgr } from '../../../model/SubscriptionMgr';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { Project } from 'app/model/project';
import { Handler, SimpleTypedHandler } from 'app/types/handlers';

export type AttributeConditionsDialogConfig = {
  project: Project;
  criteria?: AvailCriteria;
  attribute?: ConfigAttribute;
  handler?: TypedHandler<AvailCriteria>;
};

@Component({
  selector: 'app-attribute-conditions-dialog-entry',
  templateUrl: './attribute-conditions-dialog-entry.component.html',
  styleUrls: ['./attribute-conditions-dialog-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeConditionsDialogEntryComponent implements OnInit {

  public project: Project | undefined;
  public criteria: AvailCriteria | undefined;
  public attribute: ConfigAttribute | undefined;
  private handler?: TypedHandler<AvailCriteria>;
  @ViewChild('attComparisons', { static: true }) attComparisons?: AttributeComparisonComponent;

  constructor(private modal: NgbActiveModal, private messager: ModalMessagerService, private cdr: ChangeDetectorRef) { }

  public get attributeId() {
    if (!this.attribute) return -2;
    return this.attribute.id;
  }
  ngOnInit(): void {
  }
  Show(config: AttributeConditionsDialogConfig) {
    this.attribute = config.attribute;
    this.criteria = config.criteria;
    this.project = config.project;
    if(config.handler) {
      this.handler = config.handler;
    }
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
  Hide() {
    this.modal.close();
  }
  Ok() {
    if (!this.attComparisons) {
      throw new Error('view child in comparison-selector.component not found');
    }
    const criteria: AvailCriteria | undefined = this.attComparisons.ToCriteria();
    if (!criteria) {
      this.messager.Confirm('There is not enough detected information to create a new criteria. Press ok to continue editing the criteria, or press cancel to stop editing this criteria and return to your attribute configuration.',
        () => {
          // nothing to do
        },
        () => {
          this.Hide();
        },
        'There was a problem');
    } else {
      if(!!this.attribute && !this.attribute.availability) {
        this.attribute.availability = [];
      }
      if (!!this.attribute && !!this.attribute.availability) {
        let match = false;
        this.attribute.availability.every((value) => {
          if (value.id === criteria.id) {
            match = true;
            return false;
          }
          return true;
        });
        if (!match) {
          this.attribute.availability.push(criteria);
          this.messager.Notify('Criteria Added');
        } else {
          this.messager.Notify('Criteria Updated');

        }
      }
     if (!!this.handler) this.handler(criteria);
      this.Hide();

    }
  }
  Cancel() {
    this.messager.Confirm('Cancelling will abandon any information you have entered for this attribute criteria. Press Ok to confirm you wish to abandon changes, or Cancel to continue editing.',
      () => {
        this.Hide();
      },
      () => {
        // Nothing to do
      })
  }

}
@Component({
  selector: 'app-attribute-conditions-dialog',
  template: ''
})
export class AttributeConditionsDialogComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: AttributeConditionsDialogService) {

    this.subscriptionMgr.Subscribe(this.service.requests, (config: AttributeConditionsDialogConfig) => {
      this.modalRef = this.modalService.open(AttributeConditionsDialogEntryComponent, { backdrop: 'static', modalDialogClass: 'project-config-dialog' });
      (this.modalRef.componentInstance as AttributeConditionsDialogEntryComponent).Show(config);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
